module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Mary-Shelley.e071293.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Mary-Shelley.jpg
// module id = DK9v
// module chunks = 0